export const IS_DEV_MODE = import.meta.env.NODE_ENV === 'development' || false;

export const LS_BASE_URL = new URL('https://lekkeslaap.co.za');

export const STAFF_IMG_URL = 'https://static.cdn.tripco.co.za/staff/'

export const IMGIX_DOMAINS = {
    TVG_BLOG: 'tvg-blog.imgix.net',
    TVG_NEWSLETTER: 'tvg-newsletter.imgix.net',
    TRAVELGROUND: 'travelground.imgix.net',
    TRAVELGROUND_VIDEO: 'travelground.imgix.video',
    TRIPCO_STATIC: 'tripco-static.imgix.net',
}

// Image cache hostnames. IMGIX_DOMAINS stays the Imgix sources, which the R2 key scheme is built from.
export const CDN_DOMAINS = {
    STATIC: 'static.cdn.tripco.co.za',
    BLOG: 'blog.cdn.tripco.co.za',
}

export const IMGIX_DEFAULT_PARAMS = {
    auto: 'enhance,format,compress',
    fit: 'crop',
    q: 80,
    w: 1200, // Fluid <img src> fallback reuses the 1200w srcset entry instead of an original-size render
}

export const DEFAULT_SRCSET_OPTS = {
    devicePixelRatios: [1, 2, 3],
    widths: [360, 768, 1200, 1536, 1920]
}

export const FULL_WIDTH_SRCSET_OPTS = {
    ...DEFAULT_SRCSET_OPTS,
    widths: [...DEFAULT_SRCSET_OPTS.widths, 3840],
};

export const BOOKING_STATUS_MAPPING = {
    'Booking Onpaid': 'Booking Paid Out',
    'Booking Not-onpaid': 'Booking Not Paid Out',
};

export const N_PROGRESS_CONFIG = {
    color: '#EC772D', // LekkeSlaap Brand Colour
}

export const NOT_AVAILABLE_SYMBOL = '—';
